import * as React from 'react';
import { Button, Input, Modal, Form, Label } from 'semantic-ui-react';
import ReactTable from 'react-table';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { OAuthClientStatus } from '../../api';
import RequestParameters from '../../api/parameters';
const FontAwesome = require('react-fontawesome');
const fileDownload = require('js-file-download');

class State {
    data: any;
    showImportModal: boolean;
    file: any;
    testUrl: string;
    addPattern: any;
    addString: any;
    showDelModal: boolean;
    showAddModal: boolean;
    showTestModal: boolean;
    selectedRow: any;
    testResponse: string;
    sysName: string;
    showErrModal: boolean;
    modalTitle: string;
}

interface Props {

}

export default class AliasConfigView extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            data: [],
            showImportModal: false,
            file: null,
            testUrl: '',
            addPattern: '',
            addString: '',
            showTestModal: false,
            showAddModal: false,
            showDelModal: false,
            showErrModal: false,
            selectedRow: '',
            testResponse: '',
            sysName: '',
            modalTitle: ''
        });
        this.getSystemName();
        this.deletePattern = this.deletePattern.bind(this);
        this.addPattern = this.addPattern.bind(this);
    }

    getSystemName() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/sys/status';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    __this.setState({
                        sysName: response.data.name
                    });
                } else
                    throw response;
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('getSystemName() error: ', error);
            });
    }
    addPattern() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        axios.post('http://default/api/aliases/pattern', {
            'pattern': this.state.addPattern,
            'variant': this.state.addString
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    __this.fetchPatterns();
                    __this.handleAddModalClose();
                    __this.setState({
                        addString: '',
                        addPattern: ''
                    });

                } else
                    throw response;

            })
            .catch( (error) => {
                __this.setState({
                    showErrModal: true,
                    testResponse: (error.response ? error.response.data.det : 'Operation Failed')
                });
                // tslint:disable-next-line:no-console
                console.log(error.response);
            });
    }
    fetchPatterns() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/aliases/pattern';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    __this.setState({
                        data: response.data.patterns
                    });
                } else throw response;
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
               console.log('fetchPatterns() error', error);
            });
    }

    import() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let formData = new FormData();
        formData.append('fileData', this.state.file);

        axios.post('http://default/api/aliases/pattern/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    __this.fetchPatterns();
                    __this.handleImportModalClose();
                } else
                    throw response;
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('expected patterns, got ', error);
            });
    }

    testPatterns() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/aliases/pattern/test?input=' + encodeURIComponent(this.state.testUrl);
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    let displayText = 'Matched with ' +  response.data.result.pattern;
                    __this.setState({
                        showErrModal: true,
                        testResponse: displayText,
                    });
                } else throw response;
            })
            .catch((error) => {
                __this.setState({
                    showErrModal: true,
                    testResponse: (error.response ? error.response.data.det : 'No matching pattern in subsystem')
                });
            });
    }
    deletePattern(fetch: boolean) {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/aliases/pattern' ;

        axios.delete(url, {
            data: { pattern: this.state.selectedRow.original.pattern }
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    if (fetch) {
                        __this.fetchPatterns();
                        __this.handleDeleteModalClose();
                    }
                } else
                    throw response;
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('delete pattern error, got: ', error);
            });
    }
    editPattern() {
       this.deletePattern(false);
       this.addPattern();
    }

    handleImportModalClose() {
        this.setState({
            showImportModal: false
        });
    }
    handleTestModalClose() {
        this.setState({
            showTestModal: false,
            testResponse: ''
        });
    }
    handleDeleteModalClose() {
        this.setState({
            showDelModal: false
        });
    }
    handleAddModalClose() {
        this.setState({
            showAddModal: false,
            addString: '',
            addPattern: ''
        });
    }
    handleErrModalClose() {
        this.setState({
           showErrModal: false
        });
    }
    buttonRenderer(props: any) {

        return (
            <div className="cellIcons">
                {/* tslint:disable-next-line:max-line-length */}
                <Button className="grid-hamburger-menu-button" title="Edit Pattern" onClick={(event, data) => this.setState({selectedRow: props, showAddModal: true, modalTitle: 'Edit Pattern', addPattern: props.original.pattern, addString: props.original.variant})}>
                    <FontAwesome name="far fa-edit"/>
                </Button>
                <Button
                    className="grid-hamburger-menu-button iconSpacing"
                    title="Delete Pattern"
                    onClick={() => this.setState({selectedRow: props, showDelModal: true})}
                >
                    <FontAwesome name="fas fa-trash-o"/>
                </Button>
            </div>
        );
    }
    render() {
        const columns = [{
            width: 10
        }, {
            width: 55,
            align: 'center',
            Cell: (props: any) => this.buttonRenderer(props)
        }, {
            Header: 'Pattern',
            accessor: 'pattern',
            headerStyle: { textAlign: 'left' },
            Cell: (props: any) => <div title={props.value}>{props.value}</div>

        }, {
            Header: 'String',
            accessor: 'variant',
            headerStyle: { textAlign: 'left' },
            Cell: (props: any) => <div title={props.value}>{props.value}</div>
        }];

        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        return (
            <div className="view-content" id="assets">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Variant Aliasing</div>
                        </div>
                    </div>

                </div>
                <div className="filterPanel">
                    <Button
                        className="filterPanel-right-primary-btn"
                        content="Add Pattern"
                        onClick={() => this.setState({showAddModal: true, modalTitle: 'Add Pattern'})}
                    />
                    <Button
                        className="filterPanel-secondary-btn"
                        title="Test Pattern"
                        content="Test Pattern"
                        onClick={() => this.setState({showTestModal: true})}
                    />
                    <Button
                        className="filterPanel-secondary-btn"
                        title="Import Patterns"
                        content="Import"
                        onClick={() => this.setState({showImportModal: true})}
                    />
                    <OAuth.Context>{(oauth: OAuthClientStatus) => (
                        <Button
                            className="filterPanel-secondary-btn"
                            icon="file excel outline"
                            content="Export"
                            onClick={(event, data) => this.exportLog(oauth)}
                        />
                    )}</OAuth.Context>
                </div>
                <div className="view-clientarea">
                    <ReactTable
                        className="content-bg transaction-log -striped -highlight outside-scroll"
                        onFetchData={() => this.fetchPatterns()}
                        data={(this.state && this.state.data) ? this.state.data : []}
                        columns={columns}
                        defaultPageSize={30}
                        showPagination={false}
                    />
                    <Modal
                        open={this.state.showImportModal}
                        onClose={() => this.handleImportModalClose()}
                        size="mini"
                        style={inlineStyle.modal}
                    >
                        <Modal.Header>Import</Modal.Header>
                        <Modal.Content>
                            <Form>
                                <Form.Field>
                                    <Input
                                        placeholder="Enter the Alias"
                                        type="file"
                                        onChange={(e: any) => this.setState({file: e.target.files[0]})}
                                    />
                                </Form.Field>
                            </Form>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button className="filterPanel-primary-btn modal-button-padding" onClick={() => this.import()}>
                                Import
                            </Button>
                            <Button className="filterPanel-secondary-btn modal-button-padding" onClick={() => this.handleImportModalClose()}>
                                Cancel
                            </Button>
                        </Modal.Actions>
                    </Modal>
                    <Modal
                        open={this.state.showTestModal}
                        onClose={() => this.handleTestModalClose()}
                        size="small"
                        style={inlineStyle.modal}
                    >
                        <Modal.Header>Test Patterns</Modal.Header>
                        <Modal.Content>
                            <Form>
                                <Form.Field>
                                    <Input
                                        placeholder="Enter the URL"
                                        onChange={(event: any, data: any) => this.setState({testUrl: data.value})}
                                    />
                                </Form.Field>
                                <Form.Group grouped className="align-center">
                                    <Button className="filterPanel-primary-btn modal-button-padding" onClick={() => this.testPatterns()}>
                                        Test
                                    </Button>
                                </Form.Group>
                            </Form>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button className="filterPanel-primary-btn modal-button-padding" onClick={() => this.handleTestModalClose()}>
                                OK
                            </Button>
                        </Modal.Actions>
                    </Modal>
                    <Modal
                        open={this.state.showDelModal}
                        onClose={() => this.handleDeleteModalClose()}
                        size="mini"
                        style={inlineStyle.modal}
                    >
                        <Modal.Header>Delete Pattern</Modal.Header>
                        <Modal.Content>
                            <Form>
                                <Form.Field>
                                    Are you sure you want to delete this pattern?
                                </Form.Field>
                            </Form>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                className="filterPanel-secondary-btn modal-button-padding"
                                onClick={() => this.deletePattern(true)}
                            >
                                Yes
                            </Button>
                            <Button className="filterPanel-primary-btn modal-button-padding" onClick={() => this.handleDeleteModalClose()}>
                                No
                            </Button>
                        </Modal.Actions>
                    </Modal>
                    <Modal
                        open={this.state.showAddModal}
                        onClose={() => this.handleAddModalClose()}
                        size="mini"
                        style={inlineStyle.modal}
                    >
                        <Modal.Header>{this.state.modalTitle}</Modal.Header>
                        <Modal.Content>
                            <Form>
                                <Form.Field>
                                    <Label className="filterPanelLabel">
                                        Pattern:
                                    </Label>
                                    <Input
                                        value={this.state.addPattern}
                                        onChange={(event: any, data: any) => this.setState({addPattern: data.value})}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Label className="filterPanelLabel">
                                        String:
                                    </Label>
                                    <Input
                                        value={this.state.addString}
                                        onChange={(event: any, data: any) => this.setState({addString: data.value})}
                                    />
                                </Form.Field>
                            </Form>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                className="filterPanel-primary-btn modal-button-padding"
                                onClick={() => (this.state.modalTitle === 'Add Pattern' ? this.addPattern() : this.editPattern())}
                            >
                                {(this.state.modalTitle === 'Add Pattern' ? 'Add' : 'Save')}
                            </Button>
                            <Button className="filterPanel-secondary-btn modal-button-padding" onClick={() => this.handleAddModalClose()}>
                                Cancel
                            </Button>
                        </Modal.Actions>
                    </Modal>
                    <Modal
                        open={this.state.showErrModal}
                        onClose={() => this.handleErrModalClose()}
                        size="mini"
                        style={inlineStyle.modal}
                    >
                        <Modal.Header/>
                        <Modal.Content>
                            <Form>
                                <Form.Field>
                                    {this.state.testResponse}
                                </Form.Field>
                            </Form>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button className="filterPanel-primary-btn modal-button-padding" onClick={() => this.handleErrModalClose()}>
                                OK
                            </Button>
                        </Modal.Actions>
                    </Modal>
                </div>
            </div>
        );
    }

    exportLog(oauth: OAuthClientStatus) {
        let now = new Date(); let filename = '';
        let url = (oauth.secureHost ? 'https' : 'http') + '://default/api/export';
        if (oauth.sys.name && oauth.sys.name.length !== 0) {
            // let sysname = encodeURIComponent(oauth.sys.name);
            filename = 'IQAliasPattern-' + oauth.sys.name + '-';
        } else {
            filename = 'IQAliasPattern-';
        }
        filename += (now.getFullYear() + ('0' + (now.getUTCMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2));
        filename += '-';
        filename += (('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()).slice(-2) + ('0' + now.getSeconds()).slice(-2));
        filename += '.tsv';

        const params = new RequestParameters({
            dataType: 'AliasPattern',
            exportFormat: 'tsv',
            filename: filename
        }).queryString();

        if (params.length > 0)
            url += '?' + params;

        axios.post(url)
            .then(function (response: AxiosResponse) {
                let stringObject = response.data;
                fileDownload(stringObject, filename);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('Export Alias Pattern error: ', error);
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/aliasConfig.tsx